import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import AOS from "aos";
import "aos/dist/aos.css";


const PartnersComponent = () => {
  const { t } = useTranslation();

  useEffect(() => {
    AOS.init({
      duration: 1200,
      once: true,
    });
  }, []);

  const partners = [
    {
      id: 1,
      image: "assets-v2/images/partners/YU.png",
      name: t("partners.yu.name"),
      description: t("partners.yu.description"),
      link: "https://yu.edu.sa/?lang=ar",
    },
    {
      id: 2,
      image: "assets-v2/images/partners/ka.jpeg",
      name: t("partners.ka.name"),
      description: t("partners.ka.description"),
      link: "https://yu.edu.sa/creativity-and-innovation-center-ar/?lang=ar",
    },
  ];
  

  const styles = {
    section: {
      backgroundImage: "url('assets-v2/images/partners/al-yamamah.webp')",
      backgroundAttachment: "fixed",
      backgroundSize: "cover",
      backgroundPosition: "center",
      padding: "60px 20px",
      textAlign: "center",
      fontFamily: "'Poppins', sans-serif",
    },
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.6)",
      padding: "60px 20px",
      borderRadius: "12px",
    },
    header: {
      marginBottom: "40px",
    },
    title: {
      fontSize: "32px",
      fontWeight: "700",
      color: "#ffffff",
      marginBottom: "10px",
      position: "relative",
      display: "inline-block",
    },
    titleAfter: {
      content: "''",
      display: "block",
      width: "60px",
      height: "4px",
      backgroundColor: "#3498db",
      margin: "10px auto 0",
    },
    description: {
      fontSize: "18px",
      color: "#bdc3c7",
      marginTop: "10px",
    },
    grid: {
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "center",
      gap: "30px",
    },
    card: {
      backgroundColor: "#ffffff",
      borderRadius: "12px",
      padding: "20px",
      width: "300px",
      boxShadow: "0 10px 20px rgba(0, 0, 0, 0.1)",
      transition: "transform 0.3s ease, box-shadow 0.3s ease",
      cursor: "pointer",
      textAlign: "center",
      position: "relative",
      overflow: "hidden",
   
    },
    cardHover: {
      transform: "translateY(-10px) scale(1.03)",
      boxShadow: "0 15px 30px rgba(0, 0, 0, 0.2)",
    },
    waveEffect: {
        position: "absolute",
        top: "0",
        left: "0",
        width: "100%",
        height: "100%",
        background: "linear-gradient(135deg, rgba(52, 152, 219, 0.1), rgba(41, 128, 185, 0.1))",
        clipPath: "circle(80% at 50% -20%)",
        zIndex: "0",
        transition: "clip-path 0.5s ease-in-out",
      },
      waveHover: {
        clipPath: "circle(110% at 50% 50%)",
      },
    logo: {
      width: "80px",
      height: "auto",
      marginBottom: "15px",
      transition: "transform 0.3s ease",
    },
    logoHover: {
      transform: "rotate(10deg) scale(1.1)",
    },
    partnerName: {
      fontSize: "20px",
      fontWeight: "600",
      color: "#34495e",
      marginBottom: "10px",
    },
    partnerDescription: {
      fontSize: "16px",
      color: "#7f8c8d",
      lineHeight: "1.6",
    },
  };

  return (
    <div style={styles.section}>
      <div style={styles.overlay}>
        <div style={styles.header}>
          <h2 style={styles.title} data-aos="fade-up">
            {t("partners.title")}
            <span style={styles.titleAfter}></span>
          </h2>
          <p style={styles.description} data-aos="fade-up" data-aos-delay="200">
            {t("partners.description")}
          </p>
        </div>
        <div style={styles.grid}>
  {partners.map((partner) => (
    <a
      key={partner.id}
      href={partner.link}
      target="_blank"
      rel="noopener noreferrer"
      style={{ textDecoration: "none" }} // إزالة خط الرابط
    >
      <div
        style={styles.card}
        data-aos="zoom-in"
        onMouseEnter={(e) => {
          Object.assign(e.currentTarget.style, styles.cardHover);
          Object.assign(
            e.currentTarget.querySelector(".wave-effect").style,
            styles.waveHover
          );
        }}
        onMouseLeave={(e) => {
          Object.assign(e.currentTarget.style, {
            transform: "translateY(0)",
            boxShadow: "0 10px 20px rgba(0, 0, 0, 0.1)",
          });
          Object.assign(
            e.currentTarget.querySelector(".wave-effect").style,
            styles.waveEffect
          );
        }}
      >
        <div className="wave-effect" style={styles.waveEffect}></div>
        <img
          src={partner.image}
          alt={partner.name}
          style={styles.logo}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = styles.logoHover.transform;
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "";
          }}
        />
        <h3 style={styles.partnerName}>{partner.name}</h3>
        <p style={styles.partnerDescription}>{partner.description}</p>
      </div>
    </a>
  ))}
</div>

      </div>
    </div>
  );
};

export default PartnersComponent;
